export function safelyParseJson<T = unknown>(string: string): T | undefined {
  try {
    return JSON.parse(string);
  } catch (e) {
    return;
  }
}
